import { Button, styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

import { CatalogueType } from './types';
import type { IsMobileProps } from './types';

export const Root = styled('div', {
  shouldForwardProp: shouldForwardProp(),
})<IsMobileProps>(({ theme, isMobile }) => ({
  margin: isMobile ? theme.spacing(4, 6, 10, 4) : theme.spacing(6, 6, 0),
  display: 'flex',
  flexDirection: 'row',
}));

export const CurrentCatalog = styled('div')(() => ({
  width: 200,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
}));

export const NextCatalog = styled('div')(({ theme }) => ({
  width: 155,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: theme.spacing(0, 6),
}));

export const Title = styled('h6')(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 'normal',
  textAlign: 'center',
  fontSize: theme.typography.pxToRem(20),
  '&:hover': {
    color: theme.palette.default.light,
  },
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));

export const Validity = styled('p')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.typography.pxToRem(14),
  margin: theme.spacing(1, 0, 0),
}));

export const Centered = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: 200,
});

export const CatalogueLink = styled('a')<{ hoverEffect?: boolean }>(({ theme, hoverEffect = false }) => ({
  textDecoration: 'none',
  '&:hover': {
    color: hoverEffect ? theme.palette.default.light : 'none',
  },
}));

export const CatalogueDetailButton = styled(Button)<{ hoverEffect?: boolean }>(({ theme, hoverEffect = false }) => ({
  margin: theme.spacing(3, 0, 0),
  '&:hover': {
    background: hoverEffect ? theme.palette.grey : 'none',
  },
}));

export const ImageWrapper = styled('div')<{ catalogue: CatalogueType }>(({ theme, catalogue }) => ({
  width: catalogue === CatalogueType.Current ? 200 : 100,

  '& > img': {
    borderRadius: theme.spacing(1),
    alignSelf: 'center',
    justifySelf: 'center',
  },
}));

export const CallToAction = styled('div')(({ theme }) => ({
  width: 330,
  margin: theme.spacing(3, 0, 4),
}));

export const CTAText = styled('p')<IsMobileProps>(({ theme, isMobile }) => ({
  fontSize: theme.typography.pxToRem(isMobile ? 12 : 15),
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.primary,
  textAlign: isMobile ? 'center' : 'left',
  textDecoration: isMobile ? 'underline' : 'none',
  textTransform: isMobile ? 'uppercase' : 'none',
  textUnderlineOffset: isMobile ? theme.spacing(1) : 'auto',
  textDecorationThickness: isMobile ? 2 : 'auto',
  margin: isMobile ? theme.spacing(3, 0, 0) : 0,
}));

export const MobileWrapper = styled('div')(() => ({
  height: 103,
  width: '100%',
}));
